import React from 'react';
import ImportDataModal from './import_data_modal/ImportDataModal';
import { TImportData } from './types';

const ImportData: React.FC<TImportData> = ({ isOpen, onCancelAction }) => {
  return <ImportDataModal isOpen={isOpen} onCancelAction={onCancelAction} />;
};
export default ImportData;
